import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  CreateManualPaymentRequest,
  CreateSmeManualPaymentRequest,
} from '../../features/payment/paymentSlice';
import { restructureErrorMessage } from '../../helpers/errorMessage';
import {
  createManualPayment,
  createSmeManualPayment,
  getPaymentHistory,
  uploadManualPayment,
  uploadSmeManualPayment,
} from './paymentService';

export const getPaymentHistoryThunk = createAsyncThunk(
  'payment/getAllHistory',
  async (requestData: any, thunkAPI) => {
    try {
      return await getPaymentHistory(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createManualPaymentThunk = createAsyncThunk(
  'payment/createManualPayment',
  async (requestData: CreateManualPaymentRequest, thunkAPI) => {
    try {
      return await createManualPayment(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const uploadManualPaymentFileThunk = createAsyncThunk(
  'payment/uploadManualPaymentFile',
  async (requestData: any, thunkAPI) => {
    try {
      return await uploadManualPayment(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createSmeManualPaymentThunk = createAsyncThunk(
  'payment/createSmeManualPayment',
  async (requestData: CreateSmeManualPaymentRequest, thunkAPI) => {
    try {
      return await createSmeManualPayment(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const uploadSmeManualPaymentFileThunk = createAsyncThunk(
  'payment/uploadSmeManualPaymentFile',
  async (requestData: any, thunkAPI) => {
    try {
      return await uploadSmeManualPayment(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
